import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d8c6c86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PaneListSamples CustomScrollbar" }
const _hoisted_2 = { class: "PaneIntro" }
const _hoisted_3 = {
  key: 0,
  class: "List"
}
const _hoisted_4 = { class: "ListLabels PaneLine Disabled" }
const _hoisted_5 = { class: "Label" }
const _hoisted_6 = { class: "LabelGroup" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_8 = { class: "ListContent" }
const _hoisted_9 = { class: "List" }
const _hoisted_10 = { class: "ListLabels" }
const _hoisted_11 = { class: "Label" }
const _hoisted_12 = { class: "PaneEmptyText" }
const _hoisted_13 = {
  key: 2,
  class: "List"
}
const _hoisted_14 = { class: "ListLabels" }
const _hoisted_15 = { class: "Label" }
const _hoisted_16 = { class: "LabelGroup" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_18 = { class: "ListContent" }
const _hoisted_19 = {
  key: 3,
  class: "List"
}
const _hoisted_20 = { class: "ListLabels" }
const _hoisted_21 = { class: "Label" }
const _hoisted_22 = { class: "LabelGroup" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_24 = { class: "ListContent" }
const _hoisted_25 = {
  key: 4,
  class: "List"
}
const _hoisted_26 = { class: "ListLabels PaneLine Disabled" }
const _hoisted_27 = { class: "Label" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_30 = { class: "ListContent" }
const _hoisted_31 = {
  key: 5,
  class: "List"
}
const _hoisted_32 = { class: "ListLabels PaneLine Disabled" }
const _hoisted_33 = { class: "Label" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_36 = { class: "ListContent" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaneTitle = _resolveComponent("PaneTitle")!
  const _component_PageVideoGuide = _resolveComponent("PageVideoGuide")!
  const _component_PaneLineSample = _resolveComponent("PaneLineSample")!
  const _component_PaneLink = _resolveComponent("PaneLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PaneTitle, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.mixWB('SAMPLES_AND_ASSESSMENTS')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(_ctx.mixWB('OVERVIEW_OF_ALL_MATERIAL_SAMPLES_AND_THEIR_ANALYSIS_RESULTS')), 1),
      _createVNode(_component_PageVideoGuide, { guide: "samples" })
    ]),
    (_ctx.samples.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.mixWB('SAMPLES')) + " (" + _toDisplayString(_ctx.samples.length) + ")", 1),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usedAnalysisTestGroups, (analysis) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: analysis.id,
                  class: "Label"
                }, _toDisplayString(_ctx.mixWB(analysis.translation)), 1))
              }), 128))
            ]),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.samples, (sample) => {
              return (_openBlock(), _createBlock(_component_PaneLink, {
                key: sample.id,
                class: "PaneLine",
                "pane-id": sample.hashID
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_PaneLineSample, {
                    sample: sample,
                    equivalentBase: _ctx.projectSamples
                  }, null, 8, ["sample", "equivalentBase"])
                ]),
                _: 2
              }, 1032, ["pane-id"]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.mixWB('SAMPLES')), 1)
            ])
          ]),
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.mixWB('NO_SAMPLES_TAKEN')), 1)
        ], 64)),
    (_ctx.externalEquivalents.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.mixWB('SAMPLES_FROM_A_DIFFERENT_PROJECT')) + " (" + _toDisplayString(_ctx.externalEquivalents.length) + ")", 1),
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usedAnalysisTestGroups, (analysis) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: analysis.id,
                  class: "Label"
                }, _toDisplayString(_ctx.mixWB(analysis.translation)), 1))
              }), 128))
            ]),
            _hoisted_17
          ]),
          _createElementVNode("div", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.externalEquivalents, (sample) => {
              return (_openBlock(), _createBlock(_component_PaneLink, {
                key: sample.id,
                class: "PaneLine",
                "pane-id": sample.hashID
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_PaneLineSample, { sample: sample }, null, 8, ["sample"])
                ]),
                _: 2
              }, 1032, ["pane-id"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.assesments.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.mixWB('ASSESSMENTS')) + " (" + _toDisplayString(_ctx.assesments.length) + ")", 1),
            _createElementVNode("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usedAnalysisTestGroups, (analysis) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: analysis.id,
                  class: "Label"
                }, _toDisplayString(_ctx.mixWB(analysis.translation)), 1))
              }), 128))
            ]),
            _hoisted_23
          ]),
          _createElementVNode("div", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assesments, (sample) => {
              return (_openBlock(), _createBlock(_component_PaneLink, {
                key: sample.id,
                class: "PaneLine",
                "pane-id": sample.hashID
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_PaneLineSample, { sample: sample }, null, 8, ["sample"])
                ]),
                _: 2
              }, 1032, ["pane-id"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.existing.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.mixWB('EXISTING_SAMPLES')) + " (" + _toDisplayString(_ctx.existing.length) + ")", 1),
            _hoisted_28,
            _hoisted_29
          ]),
          _createElementVNode("div", _hoisted_30, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.existing, (sample) => {
              return (_openBlock(), _createBlock(_component_PaneLink, {
                key: sample.id,
                class: "PaneLine",
                "pane-id": sample.hashID
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_PaneLineSample, { sample: sample }, null, 8, ["sample"])
                ]),
                _: 2
              }, 1032, ["pane-id"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.postponed.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.mixWB('POSTPONED_SAMPLES')) + " (" + _toDisplayString(_ctx.postponed.length) + ")", 1),
            _hoisted_34,
            _hoisted_35
          ]),
          _createElementVNode("div", _hoisted_36, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.postponed, (sample) => {
              return (_openBlock(), _createBlock(_component_PaneLink, {
                key: sample.id,
                class: "PaneLine PostponedLine",
                "pane-id": sample.hashID
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_PaneLineSample, { sample: sample }, null, 8, ["sample"])
                ]),
                _: 2
              }, 1032, ["pane-id"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}